module.exports = __webpack_public_path__ + "img/seal.dca4a279.png";